import script from "./SchoolDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SchoolDashboard.vue?vue&type=style&index=0&id=6c4e9ffb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4e9ffb"]])

export default __exports__